export const test = typeof process !== 'undefined' && process.env.TEST;
